import { React } from 'react';
import '../Assets/common.css';

const NotFound = () => {
    return (
        <div data-elementor-type="wp-page" data-elementor-id="6" class="elementor elementor-6">
    <div data-elementor-type="wp-page" data-elementor-id="1369" class="elementor elementor-1369 ">
        <div class="elementor-element elementor-element-562c400 e-flex e-con-boxed e-con e-parent" data-id="562c400" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
            <div class="e-con-inner">
                <div class="elementor-element elementor-element-fee11f7 e-con-full e-flex e-con e-child" data-id="fee11f7" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                    <div class="elementor-element elementor-element-fcb4276 elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_animated_text" data-id="fcb4276" data-element_type="widget" data-widget_type="jkit_animated_text.default">
                        <div class="elementor-widget-container">
                            <div  class="jeg-elementor-kit jkit-animated-text jeg_module_1369_2_676b7a309513e"  data-style="highlighted" data-text="404" data-shape="underline">
                                <h1 class="animated-text">
                                    <span class="normal-text style-color"></span>
                                    <span class="dynamic-wrapper style-color">
                                        <span class="dynamic-text">404</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
                                            <path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/>
                                        </svg>
                                    </span>
                                    <span class="normal-text style-color"></span>
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div class="elementor-element elementor-element-4213b88 elementor-widget-tablet__width-initial elementor-widget elementor-widget-heading" data-id="4213b88" data-element_type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                            <h3 class="elementor-heading-title elementor-size-default">Oops! Page not found</h3>
                        </div>
                    </div>
                    <div class="elementor-element elementor-element-b6dd33f elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-text-editor" data-id="b6dd33f" data-element_type="widget" data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
							We apologize, but the page you’re looking for cannot be found. It may have been moved, deleted, or is temporarily unavailable.												
                        </div>
                    </div>
                    <div class="elementor-element elementor-element-b0ed5c0 elementor-widget__width-inherit elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_button" data-id="b0ed5c0" data-element_type="widget" data-widget_type="jkit_button.default">
                        <div class="elementor-widget-container">
                            <div  class="jeg-elementor-kit jkit-button  icon-position-before jeg_module_1369_3_676b7a3097108" >
                                <a href="#"  class="jkit-button-wrapper"  >Back to Home</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    )
}

export default NotFound;